export default "__VITE_ASSET__8ece22c9__"